import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Layout.module.css';

import Auxilliary from '../Auxilliary/Auxilliary';
import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import SideDrawer from '../../components/Navigation/SideDrawer/SideDrawer';

class Layout extends Component {
	state = {
		sideDrawerOpen: false,
	};

	toggleSideDrawer = () => {
		this.setState((prevState) => ({
			sideDrawerOpen: !prevState.sideDrawerOpen,
		}));
	};

	sideDrawerOpenHandler = () => {
		this.setState({
			sideDrawerOpen: true,
		});
	};

	sideDrawerCloseHandler = () => {
		this.setState({
			sideDrawerOpen: false,
		});
	};

	render() {
		return (
			<Auxilliary>
				<Toolbar
					isAuthenticated={this.props.isAuthenticated}
					toggleSideDrawer={this.toggleSideDrawer}
				/>
				<SideDrawer
					isAuthenticated={this.props.isAuthenticated}
					close={this.sideDrawerCloseHandler}
					open={this.state.sideDrawerOpen}
				/>
				<main className={classes.Content}>{this.props.children}</main>
			</Auxilliary>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.token !== null,
	};
};

export default connect(mapStateToProps)(Layout);
